<template>
    <div :class="{'jom-fig-group':true,'rc_mode':layout == 'rc'}" :id="data.id">
        <div v-if="layout == 'rc'" class="rc-fig-content">
          <div class="fig-item">
            <div class="fig-single">
              <jofig v-bind:data="rcFigData" isGroupImg="true"/>
            </div>
          </div>
        </div>
        <div v-else class="fig-content">
            <div class="fig-item" v-for="(item) in this.data.grid" v-bind:key="item.index">
                <div class="fig-single" v-for="(item2) in item" v-bind:key="item2.index">
                    <jofig v-bind:data="item2.data"/>
                </div>
            </div>
        </div>
        <div class="main-title">
            <p  class="theme-font">
              <component :is="'jo' + item.name" v-for="item in data.caption[0].label" v-bind:key="item.index"
                         v-bind:data="item.data"></component>{{layout=='rc' ? '&nbsp;' :''}}&nbsp;
              <component :is="'jo' + item.name" v-for="item in data.caption[0].title" v-bind:key="item.index"
                         v-bind:data="item.data"></component>
            </p>
        </div>

        <div class="sub-title">
          <p v-if="this.data.caption.length > 1"  class="theme-font">
            <component :is="'jo' + item.name" v-for="item in data.caption[1].label" v-bind:key="item.index"
                       v-bind:data="item.data"></component>{{layout=='rc' ? '&nbsp;' :''}}&nbsp;
            <component :is="'jo' + item.name" v-for="item in data.caption[1].title" v-bind:key="item.index"
                       v-bind:data="item.data"></component>
          </p>
        </div>

        <div class="table-note" v-if="this.data.note && this.data.note.length > 0">
          <div class="table-note" v-for="(noteItem,index) in this.data.note" :key="'note'+index">
            <!--<span v-if="noteItem.data[0].name && noteItem.data[0].name != 'vocab'">{{noteItem.lang=='zh'?'注：':'NOTE:'}}</span>-->
            <p v-for="(item,index) in noteItem.data">
              <component :is="'jo' + item.name" v-bind:key="index" v-bind:data="item.data"></component>
              <span v-if="index != noteItem.data.length-1 && !hasColon(item)">{{noteItem.lang=='zh'?'；':'; '}}</span>
            </p>
          </div>
        </div>
    </div>
</template>

<script>
import jointablefig from './intablefig.vue'
import jofig from './fig.vue'
import joinlineformula from '../formula/inlineformula.vue'
import joinlinegraphic from './inlinegraphic.vue'

export default {
  components: {
    jointablefig,
    jofig,
    joinlineformula,
    joinlinegraphic
  },
  props: [
    'data'
  ],
  data () {
    return {
      // rowspan: 1
      rcFigData:{}
    }
  },
  created() {
    if (this.layout == 'rc') {
      let graphics = [];
      graphics.push(this.data.alternatives);
      this.rcFigData = {
        id:this.data.id,
        graphics: graphics,
        caption:[]
      }
    }
  },
  methods:{
    hasColon(item){
      let hasColon = false;
      if (item.name === 'p'){
        hasColon = this.hasColon(item.data[item.data.length-1]);
      } else if (item.name==='text'){
        if(item.data.lastIndexOf(';')===item.data.length-1 ||
          item.data.lastIndexOf('；')===item.data.length-1){
          return true
        }
      }
      return hasColon;
    }
  }
}
</script>

<style lang="scss" scoped>
    .jom-fig-group{
        background-color: #ffffff;
        margin: 1.5rem 0;
        padding: 2% 10%;
        .fig-content{
            .fig-item{
                .fig-single{
                    width:100%;
                    display:flex;
                    align-items:flex-end;
                }
            }
        }
        .main-title p,.sub-title p{
            margin-top: 10px;
            font-size: 1.2rem;
            line-height: 18px;
            text-align: center;
            color: #00a2af;
            text-indent: 0;
            font-weight:bold;
        }

        .table-note{
          text-align:left;
          margin: 0 auto;
          span{
            font-weight:bold;
          }
          p{
            display:inline;
            margin: 0;
            /*font-size: 1.2rem;*/
            line-height: 18px;
            text-indent: 0;
          }
        }
      .jom-fig {
        margin: 0!important;
      }
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/fig/figgroup.vue